import { useEffect, useState } from "react";
import { useGoogleGetTokenCodeForCalenderQuery } from "../../api/api";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import SortupDialog from "../../components/common/SortupDialog";
import { GOOGLE_CALENDAR_AUTH_URL } from "../../lib/constants";

const GoogleCalenderRedirectPage = () => {
  const requiredScopes = ["https://www.googleapis.com/auth/calendar"];

  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const googleCalenderRedirectPath = localStorage.getItem(
    "googleCalenderRedirectPath"
  );

  const scopes = decodeURIComponent(location.search);
  const code = searchParams.get("code") || "";

  const hasAllRequiredScopes = requiredScopes.every((scope) =>
    scopes?.includes(scope)
  );

  const [linkAccountDialog, setLinkAccountDialog] = useState(
    !hasAllRequiredScopes
  );

  const handleRetryLinkAccount = () => {
    setLinkAccountDialog(false); // Close dialog before retrying
    window.open(GOOGLE_CALENDAR_AUTH_URL, "_self");
  };

  const handleClose = () => {
    setLinkAccountDialog(false);
    if (googleCalenderRedirectPath) {
      navigate("/services");
      localStorage.removeItem("googleCalenderRedirectPath");
    } else {
      navigate(`/store?slectedTab=2`);
    }
  };

  const { isLoading, isError, data } = useGoogleGetTokenCodeForCalenderQuery(
    {
      code: code,
    },
    {
      skip: !code || !hasAllRequiredScopes,
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    if (data?.message === "Access token generated successfully") {
      if (googleCalenderRedirectPath) {
        navigate("/services");
        localStorage.removeItem("googleCalenderRedirectPath");
      } else {
        navigate(`/store?slectedTab=2`);
      }
    }
  }, [data, isLoading]);

  if (isError) {
    return (
      <div>
        Something went wrong while linking your account. Please try again later.
      </div>
    );
  }

  if (linkAccountDialog) {
    return (
      <SortupDialog
        isOpen={linkAccountDialog}
        onClose={() => setLinkAccountDialog(false)}
        bodyClassName="max-w-[400px]"
        header="Google Calendar Link Issue"
        footerButtons={[
          {
            name: "Try Again",
            onClick: handleRetryLinkAccount,
            className: "px-6 py-3 bg-customGreenColor text-white rounded-lg",
            disabled: false,
          },
          {
            name: "Close",
            onClick: handleClose,
            className: "px-6 py-3 bg-white text-gray-900 border rounded-lg",
            disabled: false,
          },
        ]}
      >
        <div className="flex flex-col justify-center text-center gap-2 text-wrap w-[35rem]">
          <img
            src="/google-alert.png"
            alt="Warning"
            className="rounded-md h-[35rem] mb-4"
          />
          <p className="text-black text-wrap text-justify text-sm">
            It seems that Google Calendar is not linked properly to your
            account. Ensure you select the required permissions during
            authorization. Please try again using the button below.
          </p>
        </div>
      </SortupDialog>
    );
  }

  return null;
};

export default GoogleCalenderRedirectPage;
